import { useMemo } from 'react'
import { useAppSelector } from '@user/store/hooks'
import { selectAllTechRegions } from '@user/store/techRegions'
import type { Option } from '../formConfig'

export function useTechRegions() {
  const allRegions = useAppSelector(selectAllTechRegions)

  return useMemo(
    () =>
      allRegions
        .filter((r) => r.active)
        .map<Option>((r) => ({
          id: r.id,
          label: r.description,
        })),
    [allRegions],
  )
}
